import React from "react";
import ReactDOM from "react-dom/client";
import { GoogleOAuthProvider } from '@react-oauth/google';
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { State } from "./Contex/State";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="414481019921-b6rv7dlbcrhgl7o5cvjrg31o8kvjaj9m.apps.googleusercontent.com">
      <State>
        <App />
      </State>
    </GoogleOAuthProvider>    
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// 435558544834-0snq1inmdj9uqij6u7p1fo4n301bujdo.apps.googleusercontent.com
// http://414481019921-b6rv7dlbcrhgl7o5cvjrg31o8kvjaj9m.apps.googleusercontent.com/
// https://414481019921-b6rv7dlbcrhgl7o5cvjrg31o8kvjaj9m.apps.googleusercontent.com/